import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
	transform(value: string, showZero?): string {
		if (value) {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		} else {
			if (showZero) {
				return 'n/a';
			}
			return '0';
		}
	}
}
